/* Import Module */
import $ from "jquery";
import { reactive, ref } from "vue";
import { RentalContractValidate, errors } from "../validation/validation";
import { storeRentalContractRegistration } from "../axios/rentalContract/rentalContractStoreAxios";
import { storeRentalContractComplete } from "../axios/rentalContract/rentalContractCompleteAxios";
import { exportRentalContract } from "../axios/rentalContract/rentalContractExport";

/* Define Const */
export const rentalContractConfirmModalRef = ref<any>(null);
// const confirmTypeName = ref<String>("");
export const confirmTypes = reactive({
  registration: false, // 登録
  complete: false, // 完了
});

/* Define Script */
const initializeConfirmTypes = () => {
  confirmTypes.registration = false;
  confirmTypes.complete = false;
};

const setConfirmType = async (confirmType: String) => {
  await initializeConfirmTypes();

  switch (confirmType) {
    case "registration":
      confirmTypes.registration = true;
      break;
    case "complete":
      confirmTypes.complete = true;
      break;
  }
};

export const showRentalContractConfirmModal = async (confirmType: String) => {
  await setConfirmType(confirmType);
  rentalContractConfirmModalRef.value?.showModal();
};

export const closeRentalContractConfirmModal = async () => {
  initializeConfirmTypes();
  rentalContractConfirmModalRef.value?.hideModal();
};

export const clickSubmitButton = () => {
  switch (true) {
    case confirmTypes.registration:
      submitRentalContractRegistration();
      break;
    case confirmTypes.complete:
      submitRentalContractComplete();
      break;
  }
};

/**
 * [登録]ボタン押下時
 */
export const clickRentalContractRegistrationButton = async () => {
  await showRentalContractConfirmModal("registration");
};

/**
 * 登録処理 Submit
 */
const submitRentalContractRegistration = () => {
  /* Run Axios */
  storeRentalContractRegistration();
  closeRentalContractConfirmModal();
};

/**
 * [完了]ボタン押下時
 */
export const clickRentalContractCompleteButton = async () => {
  await showRentalContractConfirmModal("complete");
};

/**
 * 完了処理 Submit
 */
const submitRentalContractComplete = () => {
  /* Run Axios */
  storeRentalContractComplete();
  closeRentalContractConfirmModal();
};

/**
 * [出力]ボタン 押下時
 */
export const clickRentalContractExportButton = () => {
  /* Run Axios */
  exportRentalContract();
};
